import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { LogTemplateBuilderPage } from 'pages/logbook/LogTemplateBuilderPage'

export const Route = createFileRoute('/logbook/templates/new')({
  component: RouteComponent,
  staticData: {
    title: 'New Log Template',
  },
})

function RouteComponent() {
  const navigate = useNavigate()
  const backToLogbook = () =>
    navigate({ to: '/logbook', search: (prev) => prev })

  return (
    <LogTemplateBuilderPage
      heading='New log template'
      submitLabel='Create template'
      onSubmit={backToLogbook}
      onCancel={backToLogbook}
    />
  )
}
